export interface ICollaborator {
    userId: string;
    name: string;
    email: string;
    scopes: [CollaboratorScopes];
    sharedTo: boolean;
}

export type CollaboratorScopes = 'availability';